import env from "@/utils/env";

// Утгууд container эхлэхэд (/.env) эсвэл build хийх үед (.env.production) орно.
const LOGO = {
  light: env("VUE_APP_IMAGE_LIGHT_BASE_URL"),
  dark: env("VUE_APP_IMAGE_DARK_BASE_URL"),
  smallLight: env("VUE_APP_IMAGE_SMALL_LIGHT_URL"),
  smallDark: env("VUE_APP_IMAGE_SMALL_DARK_URL"),
  text: env("VUE_APP_LOGO_FALLBACK_TEXT"),
};

export default LOGO;
